import * as React from "react";
const SvgArchive = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}><path d="M0 0h24v24H0z" data-name="Trazado 222" style={{
    fill: "none"
  }} /><path d="m20.54 5.23-1.39-1.68A1.45 1.45 0 0 0 18 3H6a1.49 1.49 0 0 0-1.16.55L3.46 5.23A1.96 1.96 0 0 0 3 6.5V19a2.006 2.006 0 0 0 2 2h14a2.006 2.006 0 0 0 2-2V6.5a1.96 1.96 0 0 0-.46-1.27M6.24 5h11.52l.81.97H5.44zM5 19V8h14v11zm8.45-9h-2.9v3H8l4 4 4-4h-2.55z" data-name="Trazado 223" style={{
    fill: "rgba(10,4,6,.4)"
  }} /></svg>;
export { SvgArchive as ReactComponent };